export default "__VITE_ASSET__l2LUOJL3__"